import { FlightsClassTypes, type FareClassWithReward } from 'constants/flight'
import { REWARD_FOR_BASE_CABIN } from 'lib/flights/rewardFareClasses'

/**
 * Canonical cash cabins for the Maldives charter (SkyLounge intentionally excluded).
 * Used as the fare-class dropdown options and the "All cabins" cheapest-bundle comparison set.
 */
export const CHARTER_CASH_CABINS: ReadonlyArray<FlightsClassTypes> = [
  FlightsClassTypes.ECONOMY,
  FlightsClassTypes.PREMIUM,
  FlightsClassTypes.BUSINESS,
]

/**
 * Inserts reward-seat variants immediately after each cash cabin in the canonical charter order.
 * Cash cabins not in {@link CHARTER_CASH_CABINS} are omitted from the output.
 */
export function expandMaldivesCharterFareClassesWithRewards(
  fareClasses: ReadonlyArray<FlightsClassTypes>,
): Array<FareClassWithReward> {
  return CHARTER_CASH_CABINS
    .filter(fc => fareClasses.includes(fc))
    .flatMap((fc) => {
      const reward = REWARD_FOR_BASE_CABIN[fc]
      return reward ? [fc, reward] : [fc]
    })
}
